<!-- 海运订舱-数据追踪 -->
<template>
  <div class="app-main-content">
    <div class="section tab-data-tracking">
      <div style="min-width: fit-content">
        <div class=" basic-info">
          <div class="basic-info-left">
            <div style="display: flex">
              <p class="basic-info-mbl">B/L:</p>
              <el-select v-model="mblNo" no="mblNo" style="width: 250px;">
                <el-option
                  v-for="item in blNoArray"
                  :key="item.value"
                  style="font-size: 22px;font-weight: 400;"
                  :label="item.code"
                  :value="item.value"
                />
              </el-select>
              <el-button no="onDownloadTemplate" type="primary" style="margin-left: 7px;" @click="onDownloadTemplate()">{{ $t('SeaExport.DownloadPortServiceScope') }}</el-button>
            </div>
            <div class="basic-info-port">
              <port-item
                no="portOfLoading"
                icon="/static/data_tracking/u7.png"
                :title="$t('Payment.portOfLoading')"
                :value="basicInfo.loadingPort"
              />
              <port-item
                no="portOfDestination"
                icon="/static/data_tracking/u8.png"
                :title="$t('Payment.portOfDestination')"
                :value="basicInfo.destinationPort"
              />
              <port-item
                no="ContainerAmount"
                icon="/static/data_tracking/u22.png"
                :title="$t('SeaExport.ContainerAmount')"
                :value="String(jobContainerNum)"
              />
            </div>
          </div>
        </div>
        <div style="display:flex;">
          <div class="instructions">
            <span style="color:#1F75D5;">{{ $t('SeaExport.thirdPartyPrompt') }}</span>
            <span style="color:#efb336;">{{ $t('SeaExport.manualPrompt') }}</span>
            <span style="color:#CCCCCC;">{{ $t('SeaExport.promptNo') }}</span>
          </div>
        </div>
        <div class="step-info">
          <el-steps class="steps">
            <el-step
              v-for="step in stepList"
              :key="step.type"
              :title="step.name"
              style="position:relative;"
              :status="step.manualIsFinish ? 'process' : step.isFinish ? 'finish' : 'wait'"
            >
              <template slot="icon">
                <img :src="`/static/data_tracking/${step.manualIsFinish ? step.manualIcon : step.icon}`">
              </template>
              <template slot="description">
                <span v-show="step.showTime">{{ step.time }}</span>
                <div style="clear: both" />
                <span v-show="step.showNum && !step.manualIsFinish">{{ $t('SeaExport.ContainerQuantity') + `${step.containerNum > jobContainerNum ?
                  jobContainerNum : step.containerNum}/${jobContainerNum}` }}</span>
              </template>

              <template slot="description">
                <div
                  class="planned"
                  :class="[!step.plannedTime ? 'grey' : step.plannedColor ? 'blue' : 'orange', step.time ? 'top' : '']"
                >
                  <span v-if="step.type === 'actualBerthPlanDate'" style="font-size:16px;">{{
                    $t('SeaExport.PlannedBerthing') }}</span>
                  <span v-if="step.type === 'actualUnberthPlanDate'" style="font-size:16px;">{{
                    $t('SeaExport.PlanDeparture') }}</span>
                  <span>{{ step.plannedTime }}</span>
                </div>
              </template>
            </el-step>
          </el-steps>
        </div>
        <div v-if="isViewContainerInformation" class="app-main-inner-row container-info">
          <div ref="refName" class="container-info-title title">
            <h2>{{ $t('SeaExport.ContainerInfo2') }}</h2>
            <h2>Container information</h2>
          </div>
          <div class="container-info-main">
            <div class="container-info-list">
              <ul>
                <li
                  v-for="container in containerList"
                  :key="container.containerNo"
                  :class="curContainer === container.containerNo ? 'isActive' : ''"
                  @click="changeContainer(container)"
                >
                  <span>{{
                    `${container.containerNo}` }}</span>
                </li>
              </ul>
            </div>
            <div class="container-info-details">
              <div class="container-info-left">
                <section class="container-info-section">
                  <p class="title">{{ $t('SeaExport.DetailedData') }}</p>
                  <details-table :details="containerInfo" :job="job" />
                </section>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="hideWire">
        <el-dialog
          v-dialogDrag
          :visible.sync="dialogVisible"
          :modal="false"
          :close-on-press-escape="false"
          :close-on-click-modal="false"
          width="450px"
          :before-close="cancel"
        >
          <div class="text">
            <i class="el-icon-warning" />
            <div style="font-size:14px;">
              {{ $t('SeaExport.DetectionOfBasicTab') }}<span class="red">{{ containersText.toString().replaceAll('、') }}</span>{{ $t('SeaExport.InconsistentThePortAreaReturn') }}<span class="red">{{
                containersText.toString().replaceAll('、') }}</span>{{ $t('SeaExport.PleaseTheOperationIsCorrect') }}
              <br>{{ $t('SeaExport.YouBoxAndCargoTab') }}
              <br>{{ $t('SeaExport.InconsistencyBetweenPortAreaDataAndPackingInformationTips') }}
            </div>
          </div>
        </el-dialog>
      </div>
    </div>
  </div>
</template>
<script>
import PortItem from '@/views/cargo/v0/SeaExport/components/booking/tabs/TabDataTracking/components/PortItem'
import DetailsTable from '@/views/cargo/v0/SeaExport/components/booking/tabs/TabDataTracking/components/DetailsTable'
import DetailsSteps from '@/views/cargo/v0/SeaExport/components/booking/tabs/TabDataTracking/components/DetailsSteps'
import {
  queryPortInfo,
  queryContainerList
} from '@/api/seaExport/dataTracking'
import ColumnUtils from '@/utils/ColumnUtils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { cacheName, cache } from '@/utils/cacheManager'
import StrUtils from '@/utils/StrUtils'
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import moment from 'moment'
import { SeaExportJob } from '@/class/model/booking/SeaExportJob'
import DateUtils from '@/utils/dateUtils'
import { queryApiRespLog } from '@/api/booking/job'
import { getLoading4Cxt } from '@/utils/utilBaseElement'
import { sortByMultiField } from '@/utils'
import { portContainerInfo } from '@/api/seaExport/dataTracking'
import { PortDataCompareUtils } from '@/class/cargo/model/utils/PortDataCompareUtils'
import LocalStorageUtilsNew from '@/utils/localStorageUtilsNew'
import { ExportUtils } from '@/class/cargo/model/utils/ExportUtils'

export default {
  name: 'TabDataTracking',
  components: { DetailsSteps, DetailsTable, PortItem, cargoAdvanceSelect },
  props: {
    context: { type: Object, required: true },
    job: { type: Object, required: true },
    action: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      containers: {
        eqSize: '',
        eqType: '',
        num: ''
      },
      containersText: [],
      dialogVisible: false,
      pushDataTime: {
        fileCutoff: '',
        terminalOpendate: '',
        actualBerthPlanDate: '',
        actualUnBerthPlanDate: '',
        portDischargeTime: '',
        actualPickUpTime: '',
        destPortReturnTime: '',
        berthPlanDate: '',
        unBerthPlanDate: ''
      },
      queryDataPushLog: {},
      mblNo: 'all',
      blNoArray: [],
      truckingInfo: {},
      loading: false,
      containerStepActive: null,
      isViewContainerInformation: false, // 是否显示箱货信息  参数值：0：不显示  参数值：1：显示
      basicInfo: {
        loadingPort: '',
        destinationPort: '',
        totalContainerNum: '0',
        etd: '',
        filecutoff: '',
        actualBerthPlanDate: '',
        actualUnberthPlan: '',
        mbl: 'B/L'
      },
      stepList: [
        {
          type: 'emptyPickUpTime',
          name: this.$t('SeaExport.EmptyBox'),
          icon: 'u54a.png',
          containerNum: '',
          showNum: true,
          showTime: true,
          time: '',
          isFinish: false
        }, {
          type: 'terminalOpendate',
          name: this.$t('SeaExport.EstimatedCYOpening'),
          icon: 'estimatedCYOpening.jpg',
          manualIcon: 'manualEstimatedCYOpening.png',
          containerNum: '',
          manualTime: this.job.terminalOpendate, // 预计开港
          pushTime: '',
          showNum: false,
          showTime: true,
          time: '',
          isFinish: false,
          manualIsFinish: false
        }, {
          type: 'filecutoff',
          name: this.$t('SeaExport.PortDocCutOff'),
          icon: 'u65a.png',
          manualIcon: 'u65.png',
          containerNum: '',
          manualTime: this.job.fileCutoff, // 港区截单
          pushTime: '',
          showNum: false,
          showTime: true,
          time: '',
          isFinish: false,
          manualIsFinish: false
        }, {
          type: 'approachDateNum',
          name: this.$t('SeaExport.HeavyContainerMobilization'),
          icon: 'u55a.png',
          containerNum: '',
          showNum: true,
          showTime: true,
          time: '',
          isFinish: false
        }, {
          type: 'customReleaseDateNum',
          name: this.$t('SeaExport.customsClearance'),
          icon: 'u56a.png',
          containerNum: '',
          showNum: true,
          showTime: true,
          time: '',
          isFinish: false
        }, {
          type: 'wharfReleaseDateNum',
          name: this.$t('SeaExport.DockRelease'),
          icon: 'u67a.png',
          containerNum: '',
          showNum: true,
          showTime: true,
          time: '',
          isFinish: false
        },
        {
          type: 'actualBerthPlanDate',
          name: this.$t('SeaExport.ActualBerthing'),
          icon: 'actualBerthing.png',
          manualIcon: 'manualActualBerthing.png', // 实际靠泊
          containerNum: '',
          manualTime: this.job.actualBerthPlanDate,
          plannedTime: this.job.berthPlanDate,
          plannedPushTime: '',
          plannedColor: false,
          pushTime: '',
          showNum: false,
          showTime: true,
          time: '',
          isFinish: false,
          manualIsFinish: false
        }, {
          type: 'wharfStowageDateNum',
          name: this.$t('SeaExport.AllocateVehiclesToTransportSth'),
          icon: 'u69a.png',
          containerNum: '',
          showNum: true,
          showTime: false,
          time: '',
          isFinish: false
        }, {
          type: 'actualUnberthPlanDate',
          name: this.$t('SeaExport.ActualDeparture'), // 实际离泊
          icon: 'u71a.png',
          manualIcon: 'u71.png',
          containerNum: '',
          manualTime: this.job.actualUnBerthPlanDate,
          plannedTime: this.job.unBerthPlanDate,
          plannedPushTime: '',
          plannedColor: false,
          pushTime: '',
          showNum: false,
          showTime: true,
          time: '',
          isFinish: false,
          manualIsFinish: false
        }, {
          type: 'portDischargeTime',
          name: this.$t('queryJob.Discharge'),
          icon: 'u73a.png',
          manualIcon: 'u73.png',
          containerNum: '',
          manualTime: this.job.portDischargeTime,
          pushTime: '',
          showNum: true,
          showTime: true,
          time: '',
          isFinish: false,
          manualIsFinish: false
        },
        {
          type: 'actualPickUpTime',
          name: this.$t('SeaExport.Pickup'),
          icon: 'u75a.png',
          manualIcon: 'u75.png',
          containerNum: '',
          manualTime: this.job.actualPickUpTime,
          pushTime: '',
          showNum: true,
          showTime: true,
          time: '',
          isFinish: false,
          manualIsFinish: false
        },
        {
          type: 'destPortReturnTime',
          name: this.$t('RailwayExport.ReturnBox'),
          icon: 'u77a.png',
          manualIcon: 'u77.png',
          containerNum: '',
          manualTime: this.job.destPortReturnTime,
          pushTime: '',
          showNum: true,
          showTime: true,
          time: '',
          isFinish: false,
          manualIsFinish: false
        }
      ],
      manualTimeList: {},
      curContainer: '',
      containerMap: {}, // 箱号：箱信息
      manualList: {},
      containerInfo: {},
      containerList: [],
      allContainerList: [],
      blContainersMap: {}, // 提单号对应的箱子信息
      truckingList: [], // 记录所有车牌
      jobContainerData: {
        approachDateNum: 0,
        customReleaseDateNum: 0,
        wharfReleaseDateNum: 0,
        wharfStowageDateNum: 0
      },
      portContainerMap: {} // 港区箱子信息 key 箱号： value 明细
    }
  },
  computed: {
    jobContainerNum() { // 总箱量
      if (this.job.lclMasterUuid) { // 小票只算有箱号箱量
        return this.allContainerList ? this.allContainerList.length : 0
      }
      return this.job.containers ? this.job.containers.length : 0
    }

  },
  watch: {
    mblNo(val, oldVal) {
      if (val !== oldVal) {
        this.loadData(val)
      }
    }
  },
  async created() {
    await cache.load(cacheName.CONFIG)
    this.loadConfigData()
    this.initByRoute()
    // 开港时间terminalOpendate预计开港
    // 截单日期fileCutoff港区截单
    // 实际靠泊时间actualBerthPlanDate实际靠泊
    // 实际离泊时间actualUnBerthPlanDate实际开船
    // 实际卸船时间portDischargeTime卸船
    // 实际提重时间actualPickUpTime提重
    // 实际还空时间destPortReturnTime还箱
    // 计划靠泊时间berthPlanDate
    // 计划离泊时间unBerthPlanDate
  },
  methods: {
    toPacking() {
      this.dialogVisible = false
      this.$emit('toPacking')
    },
    // 获取港区箱子
    async portContainerInfoFunc(row) {
      const params = {
        jobUuid: row.uuid,
        userId: this.$store.getters.userId,
        discriminate: 1, // 数据追踪和装箱信息用的共同接口记录港区信息是否有更新，需要区分是否要返回数据进行弹窗提醒，1代表从数据追踪页签请求，2代表从装箱信息页签进入。
        tenantId: row.tenantId
      }
      const res = await portContainerInfo(params)
      if (res.ok && res.data.length > 0) {
        this.containers = {
          eqSize: '',
          eqType: '',
          num: ''
        }
        this.containersText = []
        const containerArr = []
        for (const data of res.data) {
          data.eqtype = PortDataCompareUtils.transformEqType(data.eqtype, data.containerHeightCn)
          if (!containerArr.includes(data.containerNo)) {
            containerArr.push(data.containerNo)
          }
        }
        // 箱量不一致弹出
        const containersNum = containerArr.length
        if (row.containers.length !== containersNum) {
          this.containers.num = '箱量'
        } else {
          this.containers.num = ''
        }
        if (row.containers && row.containers.length === 0) {
          this.containers.eqType = '箱种'
          this.containers.eqSize = '箱型'
        }
        console.log('res.data', res.data)
        for (const data of row.containers) {
          row.containers.find((item) => {
            console.log('item===========1', res.data.find(target => target.eqtype.includes(data.eqType)))
          })
          if (!res.data.find(target => target.eqtype.includes(data.eqType))) {
            this.containers.eqType = '箱种'
          }
          if (!res.data.find(target => data.eqSize === target.eqsize)) {
            this.containers.eqSize = '箱型'
          }
        }
        if (this.containers.num || this.containers.eqType || this.containers.eqSize) {
          Object.keys(this.containers).forEach((item) => {
            if (this.containers[item]) {
              this.containersText.push(this.containers[item])
            }
          })
          this.dialogVisible = true
        }
      }
    },
    toTime(item, time, type) {
      if (item.targetValue && item.targetValue.slice(-2) === '.0') {
        item.targetValue = item.targetValue.substring(0, item.targetValue.length - 2)
      }
      if (item.targetValue) {
        item.targetValue = item.targetValue.replaceAll('/', '-')
      }
      if (!time[type]) {
        time[type] = item.targetValue
      }
    },
    // 数据推送日志
    async toQueryDataPushLog() {
      const loading = getLoading4Cxt(this)
      let easApiLogData = []
      try {
        easApiLogData = await queryApiRespLog(this.job.uuid).then(res => res.data)
        await new SeaExportJob(this.job).loadPushHistoryLogs()
      } finally {
        loading.close()
      }
      const dataArr = []
      const item = this.job.pushHistoryLogs
      if (item) {
        for (const k in item) {
          dataArr.push({ 'time': k, 'logs': item[k], 'isEas': false })
        }
      }
      if (easApiLogData && easApiLogData.length > 0) {
        for (const apiLog of easApiLogData) {
          dataArr.push({ 'time': apiLog.time, 'logs': apiLog.logs, 'isEas': true })
        }
      }
      if (dataArr && dataArr.length > 0) {
        // 排序 按时间降序
        // 确保切换后重置了时间，避免使用上次时间进行对比
        const pushTime = {
          fileCutoff: '',
          terminalOpendate: '',
          actualBerthPlanDate: '',
          actualUnBerthPlanDate: '',
          portDischargeTime: '',
          actualPickUpTime: '',
          destPortReturnTime: '',
          berthPlanDate: '',
          unBerthPlanDate: ''
        }
        sortByMultiField(dataArr, ['time'], true)
        this.queryDataPushLog = dataArr
        this.queryDataPushLog.forEach((item) => {
          // 每个logs中只取第一个值
          if (item.logs) {
            for (const i of item.logs) {
              switch (i.fieldName) {
                case '截单日期':
                  this.toTime(i, pushTime, 'fileCutoff')
                  break
                case '开港时间':
                case '开港日期':
                  this.toTime(i, pushTime, 'terminalOpendate')
                  break
                case '计划靠泊时间':
                  this.toTime(i, pushTime, 'berthPlanDate')
                  break
                case '实际靠泊时间':
                  this.toTime(i, pushTime, 'actualBerthPlanDate')
                  break
                case '计划离泊时间':
                  this.toTime(i, pushTime, 'unBerthPlanDate')
                  break
                case '实际离泊时间':
                  this.toTime(i, pushTime, 'actualUnBerthPlanDate')
                  break
                case '实际卸船时间':
                  this.toTime(i, pushTime, 'portDischargeTime')
                  break
                case '实际提重时间':
                  this.toTime(i, pushTime, 'actualPickUpTime')
                  break
                case '实际还空时间':
                  this.toTime(i, pushTime, 'destPortReturnTime')
                  break
              }
            }
          }
        })
        this.pushDataTime = { ...pushTime }
      }
    },
    // 获取业务的装箱信息明细
    async loadContainerInfo() {
      const job = new SeaExportJob(this.job)
      const containerUsages = await job.getContainerUsages()
      // 小票
      if (job.lclMasterUuid) {
        const allContainer = []
        if (containerUsages && containerUsages.length > 0) {
          for (const usage of containerUsages) {
            if (usage.container.containerNo) {
              allContainer.push(usage.container)
            }
          }
        }
        this.allContainerList = allContainer
        this.calculationContainerNum()
        return
      }

      // 获取箱子信息
      const containers = await job.getContainers()
      this.allContainerList = containers && containers.length > 0 ? containers : []
      this.calculationContainerNum()

      // 主票
      if (job.masterFlag) {
        const jobContainerMap = {}
        if (containers && containers.length > 0) {
          for (const container of containers) {
            if (container.containerUsage && container.containerUsage.length > 0) {
              for (const usage of container.containerUsage) {
                if (!jobContainerMap.hasOwnProperty(usage.jobUuid)) {
                  jobContainerMap[usage.jobUuid] = []
                }
                if (container.containerNo) {
                  jobContainerMap[usage.jobUuid].push(container)
                }
              }
            }
          }
        }
        // 遍历小票
        const blContainersMap = {}
        const slaves = job.lclSlaves
        if (slaves && slaves.length > 0) {
          for (const slave of slaves) {
            const slavesContainer = jobContainerMap[slave.uuid]
            if (slave.mbl) {
              this.addBlSlaveContainer(blContainersMap, slave.mbl, slavesContainer)
            }
            if (slave.soNo) {
              const soNoArray = slave.soNo.split('\n')
              if (soNoArray.length > 0) {
                for (const soNo of soNoArray) {
                  if (soNo) {
                    this.addBlSlaveContainer(blContainersMap, soNo, slavesContainer)
                  }
                }
              }
            }
          }
        }
        this.blContainersMap = blContainersMap
        return
      }

      // 非主票或小票业务
      // 获取货物明细
      const poItems = await job.getPoItems()
      const usageContainerMap = {}
      if (containerUsages && containerUsages.length > 0) {
        for (const usage of containerUsages) {
          if (usage.container.containerNo) {
            usageContainerMap[usage.uuid] = usage.container
          }
        }
      }
      // 获取关单号对应的箱信息
      const blContainersMap = {}
      if (poItems && poItems.length > 0) {
        for (const poItem of poItems) {
          // 无关单号的忽略
          const soNo = poItem.soNo
          if (soNo && poItem.containerUsageKey) {
            if (!blContainersMap.hasOwnProperty(soNo)) {
              blContainersMap[soNo] = []
            }
            if (usageContainerMap.hasOwnProperty(poItem.containerUsageKey)) {
              blContainersMap[soNo].push(usageContainerMap[poItem.containerUsageKey])
            }
          }
        }
      }
      this.blContainersMap = blContainersMap
    },
    addBlSlaveContainer(blContainersMap, soNo, containers) {
      if (!blContainersMap.hasOwnProperty(soNo)) {
        blContainersMap[soNo] = []
      }
      if (!containers || containers.length === 0) {
        return
      }
      const list = blContainersMap[soNo]
      for (const container of containers) {
        const index = list.findIndex(item => container === item)
        if (index > -1) {
          continue
        }
        list.push(container)
      }
    },
    initByRoute() {
      const { mbl, plateNumber } = this.$route.query
      if (mbl) {
        const mblNoArray = mbl.split(',')
        if (mblNoArray.length > 0) {
          // this.mblNo = mblNoArray[0]
          for (const soNo of mblNoArray) {
            if (soNo) {
              const index = this.blNoArray.findIndex(p => p.value === soNo)
              if (index < 0) {
                this.blNoArray.push({ 'value': soNo, 'code': soNo })
              }
            }
          }
        }
        this.truckingInfo = { plateNumber }
      }
    },
    async onShow(row, isRefresh) {
      this.dialogVisible = false
      if (this.job.uuid) {
        await this.toQueryDataPushLog()
        const showPortContainerTips = LocalStorageUtilsNew.getConfiguration('PortContainerTips_' + this.job.uuid)
        if (!row.lclMasterUuid && this.action === 'look' && !showPortContainerTips) {
          this.portContainerInfoFunc(row)
        }
      }
      this.mblNo = 'all'
      console.log('this.pushDataTime', this.pushDataTime)
      this.stepList.map((item) => {
        switch (item.type) {
          case 'terminalOpendate':
            item.manualTime = row.terminalOpendate
            item.pushTime = this.pushDataTime.terminalOpendate
            break
          case 'filecutoff':
            item.manualTime = row.fileCutoff
            item.pushTime = this.pushDataTime.fileCutoff
            break
          case 'actualBerthPlanDate':
            item.manualTime = row.actualBerthPlanDate
            item.plannedTime = row.berthPlanDate
            item.pushTime = this.pushDataTime.actualBerthPlanDate
            item.plannedPushTime = this.pushDataTime.berthPlanDate
            break
          case 'actualUnberthPlanDate':
            item.manualTime = row.actualUnBerthPlanDate
            item.plannedTime = row.unBerthPlanDate
            item.pushTime = this.pushDataTime.actualUnBerthPlanDate
            item.plannedPushTime = this.pushDataTime.unBerthPlanDate
            break
          case 'portDischargeTime':
            item.manualTime = row.portDischargeTime
            item.pushTime = this.pushDataTime.portDischargeTime
            break
          case 'actualPickUpTime':
            item.manualTime = row.actualPickUpTime
            item.pushTime = this.pushDataTime.actualPickUpTime
            break
          case 'destPortReturnTime':
            item.manualTime = row.destPortReturnTime
            item.pushTime = this.pushDataTime.destPortReturnTime
            break
        }
      })
      await this.loadContainerInfo()
      await this.loadPortData()
      this.basicInfo.destinationPort = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Seaport, 'code', this.job.dischargingPortCode, 'englishName')
      this.basicInfo.loadingPort = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Seaport, 'code', this.job.loadingPortCode, 'englishName')
      this.loadData(this.mblNo)
      // this.mblNo = row.mbl
      this.truckingInfo = row.trucking[0]
      this.truckingList = []
      if (row.trucking && row.trucking.length > 0) {
        row.trucking.forEach(eve => {
          if (eve.plateNumber) {
            this.truckingList.push(eve)
          }
        })
      }
      this.loadSoNo(row)
    },
    loadSoNo(job) {
      const blNoArray = []
      blNoArray.push({ 'value': 'all', 'code': this.$t('constant.all') })
      this.addSoNoByJob(job, blNoArray)
      // 如果是主票、则同时加载全部小票mbl+soNo
      if (job.masterFlag) {
        // 获取小票信息
        const slaves = job.lclSlaves
        if (slaves && slaves.length > 0) {
          for (const slave of slaves) {
            this.addSoNoByJob(slave, blNoArray)
          }
        }
      }
      this.blNoArray = blNoArray
    },
    addSoNoByJob(job, blNoArray) {
      if (job.mbl) {
        const index = blNoArray.findIndex(p => p.value === job.mbl)
        if (index < 0) {
          blNoArray.push({ 'value': job.mbl, 'code': job.mbl })
        }
      }
      if (job.soNo) {
        const soNoArray = job.soNo.split('\n')
        if (soNoArray.length > 0) {
          for (const soNo of soNoArray) {
            if (soNo) {
              const index = blNoArray.findIndex(p => p.value === soNo)
              if (index < 0) {
                blNoArray.push({ 'value': soNo, 'code': soNo })
              }
            }
          }
        }
      }
    },
    async loadPortData() {
      const params = {
        jobUuid: this.job.uuid,
        tenantId: this.job.tenantId
      }
      const approachDateCandidates = (this.allContainerList || [])
        .map(item => item.approachDate)
        .filter(item => item)
      const customReleaseDateCandidates = (this.allContainerList || [])
        .map(item => item.customReleaseDate)
        .filter(item => item)
      const wharfReleaseDateCandidates = (this.allContainerList || [])
        .map(item => item.wharfReleaseDate)
        .filter(item => item)
      const getEarliestTime = (candidates) => {
        if (!candidates || candidates.length === 0) {
          return ''
        }
        let minValue = candidates[0]
        let minTimestamp = new Date(minValue).valueOf()
        for (const value of candidates) {
          const ts = new Date(value).valueOf()
          if (!Number.isNaN(ts) && (Number.isNaN(minTimestamp) || ts < minTimestamp)) {
            minTimestamp = ts
            minValue = value
          }
        }
        return minValue
      }
      const approachDate = getEarliestTime(approachDateCandidates)
      const customReleaseDate = getEarliestTime(customReleaseDateCandidates)
      const wharfReleaseDate = getEarliestTime(wharfReleaseDateCandidates)
      const emptyPickUpCandidates = (this.allContainerList || [])
        .map(item => item.emptyPickUpTime)
        .filter(item => item)
      let emptyPickUpTime = ''
      const emptyPickUpTimeNum = emptyPickUpCandidates.length
      if (emptyPickUpCandidates.length > 0) {
        let minValue = emptyPickUpCandidates[0]
        let minTimestamp = new Date(minValue).valueOf()
        for (const value of emptyPickUpCandidates) {
          const ts = new Date(value).valueOf()
          if (!Number.isNaN(ts) && (Number.isNaN(minTimestamp) || ts < minTimestamp)) {
            minTimestamp = ts
            minValue = value
          }
        }
        emptyPickUpTime = minValue
      }
      await queryPortInfo(params).then(async(res) => {
        const basicInfo = res.data
        this.stepList.forEach(item => {
          if (this.jobContainerData.hasOwnProperty(item.type)) {
            item.containerNum = this.jobContainerData[item.type]
            item.isFinish = item.containerNum > 0
          } else {
            const onlyShowTime = item.type === 'terminalOpendate' || item.type === 'filecutoff' || item.type === 'actualBerthPlanDate'
            if (onlyShowTime) {
              this.manualOrThirdParty(item)
            } else {
              if (item.type === 'emptyPickUpTime') {
                item.containerNum = emptyPickUpTimeNum
                item.time = emptyPickUpTime
              } else {
                item.containerNum = basicInfo[item.type + 'Num']
                this.manualOrThirdParty(item)
              }
            }
            if (item.type === 'approachDateNum') {
              item.time = approachDate
            }
            if (item.type === 'customReleaseDateNum') {
              item.time = customReleaseDate
            }
            if (item.type === 'wharfReleaseDateNum') {
              item.time = wharfReleaseDate
            }
            item.isFinish = (item.time || item.containerNum > 0)
          }
          if (item.type === 'approachDateNum') {
            item.time = approachDate
          }
          if (item.type === 'customReleaseDateNum') {
            item.time = customReleaseDate
          }
          if (item.type === 'wharfReleaseDateNum') {
            item.time = wharfReleaseDate
          }
          if (item.type === 'customReleaseDateNum' || item.type === 'wharfReleaseDateNum' || item.type === 'approachDateNum') {
            item.isFinish = !!item.time
          }
        })
      })

      await queryContainerList(params).then(async(res) => {
        const containerList = res.data
        const portContainerMap = {}
        if (containerList && containerList.length > 0) {
          for (const container of containerList) {
            portContainerMap[container.containerNo] = container
          }
        }

        this.portContainerMap = portContainerMap
      })
    },
    /**
     1、页签数据无值。 灰色(不考虑港区数据)
     2、港区数据无值、页签数据有值。蓝色
     3、港区数据有值、页签数据有值。 值一致时，橙色、值不一致时，取页签数据、蓝色。
     * @param item
     * @param step
     */
    manualOrThirdParty(item) {
      if (item.type === 'actualBerthPlanDate' || item.type === 'actualUnberthPlanDate') {
        if (item.plannedTime && !item.plannedPushTime) {
          item.plannedColor = true
        }
        // 都有
        if (item.plannedTime && item.plannedPushTime) {
          const plannedTime = new Date(item.plannedTime).valueOf()
          const plannedPushTime = new Date(item.plannedPushTime).valueOf()
          // 时间一致，取数据服务，橙色
          if (plannedTime === plannedPushTime) {
            item.plannedColor = false
          } else {
            // 不一致，取数据追踪，蓝色
            item.plannedColor = true
          }
        }
      }
      // 都没有，则是空
      // console.log('名称', item.name)
      // console.log('数据追踪', item.manualTime)
      // console.log('数据推送变更记录', item.pushTime)
      // console.log('数据追踪计划时间', item.plannedTime)
      // console.log('数据推送记录计划时间', item.plannedPushTime)
      // console.log('分割线=======================================')
      if (!item.manualTime) {
        item.time = ''
        item.containerNum = 0
        item.manualIsFinish = false
        return
      }
      const manualTime = new Date(item.manualTime).valueOf()
      item.time = DateUtils.customFormat(manualTime, DateUtils.STANDARD_MINUTE_TIME)
      // 数据追踪有，推送日志没有
      if (item.manualTime && !item.pushTime) {
        item.manualIsFinish = true
        return
      }
      // 都有
      if (item.manualTime && item.pushTime) {
        const manualTime = new Date(item.manualTime).valueOf()
        const pushTime = new Date(item.pushTime).valueOf()
        // 时间一致，取数据服务，橙色
        if (manualTime === pushTime) {
          item.manualIsFinish = false
        } else {
          // 不一致，取数据追踪，蓝色
          item.manualIsFinish = true
        }
      }
    },
    loadData(val) {
      const containers = this.allContainerList.filter(item => item.containerNo)
      this.containerList = val === 'all' ? (containers || []) : (this.blContainersMap.hasOwnProperty(val) ? this.blContainersMap[val] : [])
      if (val !== 'all' && (!this.containerList || this.containerList.length === 0)) {
        this.$message.warning(this.$t('SeaExport.DataTrackingBlHasNotContainer', [val]))
      }
      if (!this.containerList || this.containerList.length === 0) {
        this.containerInfo = {}
        this.curContainer = ''
        return
      }
      // 添加港区数据
      this.changeContainer(this.containerList[0])
    },
    changeContainer(container) {
      const cloneContainer = Object.assign({}, container)
      this.curContainer = cloneContainer.containerNo
      if (this.portContainerMap.hasOwnProperty(cloneContainer.containerNo)) {
        const portContainer = this.portContainerMap[cloneContainer.containerNo]
        cloneContainer.dischargingPort = portContainer.dischargingPort
      }
      // CARGO-35191 数据追踪页面，箱货信息，卸货港和目的港要显示【CARGO-35801】
      // cloneContainer.loadingPort = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Seaport, 'code', cloneContainer.loadingPort, 'englishName')
      // cloneContainer.dischargingPort = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Seaport, 'code', cloneContainer.dischargingPort, 'englishName')
      // cloneContainer.destinationPort = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Seaport, 'code', cloneContainer.destinationPort, 'englishName')
      this.containerInfo = cloneContainer
    },
    // 加载配置项
    loadConfigData() {
      this.isViewContainerInformation = Number(cache.config.get('isViewContainerInformation')) === 1
    },
    goAnchor() {
      this.$refs.refName.scrollIntoView()
    },
    // 计算指定字段的数量
    calculationContainerNum() {
      const containers = this.allContainerList
      let approachDateNum = 0
      let customReleaseDateNum = 0
      let wharfReleaseDateNum = 0
      let wharfStowageDateNum = 0
      if (containers && containers.length > 0) {
        for (const container of containers) {
          if (container.customReleaseState === 'Y' || container.customReleaseDate) { // 海关放行
            customReleaseDateNum += 1
          }
          if (container.wharfReleaseState === 'Y' || container.wharfReleaseDate) { // 码头放行
            wharfReleaseDateNum += 1
          }
          if (container.approachDate) { // 进场时间
            approachDateNum += 1
          }
          if (container.wharfStowageState === 'Y' || container.wharfStowage) { // 配载
            wharfStowageDateNum += 1
          }
        }
      }
      this.jobContainerData.approachDateNum = approachDateNum
      this.jobContainerData.customReleaseDateNum = customReleaseDateNum
      this.jobContainerData.wharfReleaseDateNum = wharfReleaseDateNum
      this.jobContainerData.wharfStowageDateNum = wharfStowageDateNum
    },
    cancel() {
      LocalStorageUtilsNew.setConfiguration('PortContainerTips_' + this.job.uuid, true)
    },
    // 下载港口服务范围
    onDownloadTemplate() {
      ExportUtils.downloadTemplateFile('查看港口支持范围.xlsx', 'booking')
    }
  }
}
</script>

<style lang="scss">
.tab-data-tracking {
  .el-dialog__wrapper {
    pointer-events: none;
  }

  .el-dialog {
    pointer-events: auto;
  }

  background-color: white;

  .basic-info {
    display: flex;
    border-bottom: 1px solid #DCDFE6;
    min-width: fit-content;
    padding-bottom: 15px;
    margin: 10px 15px;

    &-left {
      display: flex;
      flex-direction: column;
    }

    &-right {
      flex: 1;
    }

    &-mbl {
      font-size: 22px;
      font-weight: 400;
      margin: 0;
    }

    &-port {
      flex: 1;
      display: flex;
      margin-top: 20px;
    }

    &-time {
      min-width: 200px;
      margin-left: 100px;

      span {
        margin: 0;
        text-align: right;
      }
    }

    .basic-info-time {
      .basic-span {
        margin-bottom: 8px;
      }
    }
  }

  .step-info {
    border-bottom: 1px solid #DCDFE6;
    padding-bottom: 15px;
    margin: 10px 0;

    .steps {
      flex: 1;
      min-width: 1100px;
      margin: 30px;

      .planned {
        display: flex;
        flex-direction: column;
        position: absolute;
        top: -150px;
        left: 0;
      }

      .grey {
        color: #c7c6c6;
      }

      .orange {
        color: #efb336;
      }

      .blue {
        color: #1F75D5;
      }

      .top {
        top: -67px;
      }
    }

    .el-step__icon {
      display: inline-flex;
      width: 50px;
      height: 50px;
      border: none;
      background-color: #dfeefc;
    }

    .el-step {

      &__title,
      &__description,
      &__head {
        &.is-process {
          color: #1F75D5;
        }

        &.is-finish {
          color: #efb336;
        }

        &.is-wait {
          -webkit-filter: grayscale(100%);
          /* Chrome, Safari, Opera */
          filter: grayscale(100%);
        }
      }
    }

    .el-step.is-horizontal .el-step__line {
      height: 2px;
      top: 23px;
      left: 0;
      right: 0;
    }
  }

  .container-info {
    padding-bottom: 15px;
    margin: 10px 15px;
    flex-direction: column;

    &-main {
      display: flex;
      width: 100%;
      flex-direction: column;
    }

    &-list {
      ul {
        list-style: none;
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        padding: 0;
        height: auto;

        li {
          width: 200px;
          text-align: center;
          border: 1px solid transparent;
          padding: 5px;
          border-radius: 12px;
          cursor: pointer;
          margin: 5px 15px;
          border: 0.5px solid #787878;
          background-color: white;

          &.isActive {
            color: black;
            text-align: center;
            background-color: #9bddff;
          }

          &:hover {
            background-color: #dfeefc;
          }

          span {
            line-height: 26px;
          }
        }
      }
    }

    &-details {
      display: flex;
    }

    &-left {
      flex: 1;
    }

    &-right {
      width: 400px;
    }

    &-title {
      font-size: 20px;
      text-align: left;

      p {
        margin: 0;
        width: fit-content;
      }
    }

    &-section {
      .title {
        font-size: 16px;
        padding: 0;
      }
    }
  }

  .instructions {
    text-align: right;
    flex: 1;

    span {
      display: block;
      margin-top: 5px;
    }
  }
}

.tab-data-tracking .step-info .el-step__description.is-wait {
  -webkit-filter: grayscale(0%);
  filter: grayscale(0%);
}

.hideWire {
  .el-dialog {
    margin-right: 50px !important;

    .el-dialog__header {
      border: none;
    }
  }

  .text {
    display: flex;
    align-items: center;
    font-size: 14px;

    i {
      font-size: 16px;
      font-size: 20px;
      margin-right: 5px;
      color: #E6A23F;
    }

    .see {
      color: rgb(31, 117, 213);
      cursor: pointer;
      font-size: 14px;
    }
  }

  .red {
    color: red;
    font-size: 14px;
  }
}
</style>
